import { ready } from "@/lib/ready";
import dialog from "@/lib/easy-dialog";
import { removeNode } from "@/lib/dom/removeNode";
import { on } from "@/lib/dom/on";

ready(() => {
  if (document.getElementById("shareResult")) {
    dialog.open({
      container: {
          content: '<a href="javascript:void(0)" title="close" class="close_btn" id="closeBtn"><i></i></a><div style="font-size:20px; text-align:center; padding:10px 20px;font-family: Galyon,Helvetica,Arial,sans-serif;">' + document.getElementById("shareResult")!.innerHTML + '</div>'
      }
    });
  }
  if (document.getElementById("shareMVP")) {
    //弹出打开
    dialog.open({
      container: {
        header: '',
        content: document.getElementById("shareMVP")!.innerHTML,
      }
    })

    // 推送datalay
    window.dataLayer.push({
      event: "common_event",
      eventCategory: 'Share MVP',
      eventAction: 'Popup',
      eventLabel: document.querySelector<HTMLInputElement>('#S_AID')!.value, //CustomerA ID
      eventValue: document.querySelector<HTMLInputElement>('#S_BID')!.value //CustomerB ID if login
    });

    //移除share mvp节点
    removeNode("#shareMVP")

    const AddSharedMVP = (aid: string, key: string) => {
      window.dataLayer.push({
        event: "common_event",
        eventCategory: 'Share MVP',
        eventAction: 'Redeem',
        eventLabel: document.querySelector<HTMLInputElement>('#S_AID')!.value, //CustomerA ID
        eventValue: document.querySelector<HTMLInputElement>('#S_BID')!.value //CustomerB ID if login
      });
      const url = '/Ajax/Customer.aspx/AddSharedMVP';
      const param = { ACustomerID: aid, Key: key };

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(param),
      })
        .then(response => response.json())
        .then(res => {
          if (res.d) {
            const data = JSON.parse(res.d);
            if (data.Code == -1 && data.Msg == 'Not Login') {
              window.location.href = document.querySelector<HTMLElement>('.yeti-popup')!.dataset['h1']!;
              return;
            }
            dialog.open({
                container: {
                    content: '<a href="javascript:void(0)" title="close" class="close_btn" id="closeBtn"><i></i></a><div style="font-size:20px; text-align:center; padding:10px 20px;font-family: Galyon,Helvetica,Arial,sans-serif;">' + (data.Code == 1 ? data.Data : data.Msg) + '</div>'
                }
            });

            if (data.Code == 1) {
                setTimeout(function () {
                    on('.close_btn','click',function () {
                        window.location.href = '/';
                    });
                }, 300);
            }
          }
        })
    }
    //全局函数
    Object.assign(globalThis, {
      AddSharedMVP: AddSharedMVP
    });
  }
  else if (document.getElementById("shareMVPAlready")) {
    //弹出打开
    dialog.open({
      container: {
        header: '',
        content: document.getElementById("shareMVPAlready")!.innerHTML,
      }
    })

    //移除share mvp节点
    removeNode("#shareMVPAlready")
    
    on('.yeti-popup .yeti-popup-btn','click',function () {
      window.location.href = '/';
  });
  }
})